import React, {useEffect, useState} from "react";
import {Box} from "@mui/system";
import {
	ListItemAvatar,
	Avatar,
	ListItemText
} from "@mui/material";
import ListItemMenuButton from "../ListItemMenuButton";
import Typography from "@mui/material/Typography";
import {useRouter} from "next/router";
import {useTranslation} from "react-i18next";
import ActivityIcon from "../ActivityIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArchive, faEllipsisH, faPhone, faPhonePlus, faPlus, faTasks, faTrash} from "@fortawesome/pro-solid-svg-icons";
import ListItemSecondaryActionTime from "../ListItems/ListItemSecondaryActionTime";
import {useInView} from "react-intersection-observer";
import {useKeycloak} from "../../src/useKeycloak";
import {truncate} from "../../utils";
import {ListItemButtonWrapper, ListItemWrapper} from "../../styles/ListComponents";

/*
const SET_ACTIVITY_STATUS = gql`
    mutation SetActivityStatus($id: uuid = "", $status: ActivityStatusEnum = DONE) {
        updateQueueItem(pkColumns: {id: $id}, _set: {status: $status}) {
            id
        }
    }
`;

const UPDATE_ACTIVITY_SET_ENDED = gql`
mutation queueItemDone($queueItemId: uuid = "") {
  updateQueueItem(pkColumns: {id: $queueItemId}, _set: {status: DONE}) {
    status
  }
}
`;
*/

const ActivityListItem = ({queueItem, idx, showStatus = false, fetchMoreQueueItems}) => {
	const router = useRouter();
	const {t} = useTranslation();
	const {tokenParsed} = useKeycloak();
	// console.log("QUEUEITEM", queueItem);
	const domain = queueItem?.domainActivity?.domain ?? queueItem?.type;
	const [active, setActive] = useState(false);

	// eslint-disable-next-line prefer-const
	let title = "";
	// eslint-disable-next-line prefer-const
	let subTitle = "";
	// eslint-disable-next-line prefer-const
	let subSubTitle = "";

	const [nameSuggestion, setNameSuggestion] = useState(null);
	const [localName, setLocalName] = useState(false);

	const { ref, inView } = useInView({
		triggerOnce: true,
		rootMargin: "200px 0px"
	});

	const listItemMenuItems =  [
		{
			primaryText: "Create customer",
			secondaryText: "Currently private contact",
			icon: faPlus,
			visible: true,
			function: undefined //() => {  }
		},
		{
			primaryText: "Quicktask",
			secondaryText: "Make a note to yourself",
			icon: faTasks,
			visible: domain !== "TASK" && domain !== "CALLBACK",
			function: () => {
				//console.log("New Task CUSTOMER: ", customer);
				const rata = {
					pathname: "/task",
					query: {
						customer: JSON.stringify(customer),
						queueItemId: queueItem?.id,
						type: "TASK",
						domain: domain,
						receiver: customer?.phoneNumber
					}
				};
				router.push(rata);
			}
		},
		{
			primaryText: "Call",
			secondaryText: "Call this number",
			icon: faPhone,
			visible: true,
			function: undefined // () => { }
		},
		{
			primaryText: "Remember to call",
			secondaryText: "Create a task reminding you to call this customer back",
			icon: faPhonePlus,
			visible: domain !== "CALLBACK" && domain !== "TASK",
			function: () => {
				console.log("New Task CUSTOMER2: ", customer);
				const rata = {
					pathname: "/task",
					query: {
						customer: JSON.stringify(customer),
						queueItemId: queueItem?.id,
						type: "CALLBACK",
						domain: domain
					}
				};
				router.push(rata);
			}
		},
		{
			primaryText: "Archive",
			secondaryText: "Remove from list",
			icon: faArchive,
			visible: true,
			function: undefined // () => { }
		},
		{
			primaryText: "Delete",
			secondaryText: "Activity",
			icon: faTrash,
			visible: true,
			function: undefined // () => { }
		},
		{
			primaryText: "Delete all from",
			secondaryText: "Task",
			icon: faTrash,
			visible: true,
			function: undefined // () => { }
		}
	];

	useEffect(() => {
		router.events.on("routeChangeComplete", (url) => {
			if (!queueItem) return;
			const type = queueItem?.domainActivity?.domain ?? queueItem?.type;
			if (type === "TELEPHONY") {
				const customer = queueItem.domainUsers.find((participant) => participant?.category?.substring(0, 8) === "CUSTOMER");
				const id = url?.split("/").pop();
				// console.log("Route changed!", queueItem);
				setActive(id === customer?.id);
			}
			else if (type === "TASK") {
				const id = url?.split("/").pop();
				setActive(id === queueItem?.id);
			}
			else {
				setActive(false);
			}
		});
	}, []);

	const handleActivityClick = (queueItem) => {

		const employeeArray = queueItem.queueParticipants.filter((item) => item.responsibility !== "CUSTOMER").map((item) => ({organizationUserId: item.organizationUserId, responsibility: item.responsibility, firstName: item.organizationUser.firstName, lastName: item.organizationUser.lastName, userId: item.organizationUser.userId}));
		const customerArray = queueItem.queueParticipants.filter((item) => item.responsibility === "CUSTOMER").map((item) => ({
			organizationUserId: item.organizationUserId,
			responsibility: item.responsibility,
			firstName: item.organizationUser.firstName,
			lastName: item.organizationUser.lastName,
			userId: item.organizationUser.userId
		}));

		// console.log("QUEUEITEM", queueItem);
		let contact = queueItem.domainUsers.find((participant) => participant?.category?.substring(0, 8) === "CUSTOMER");
		if (!contact) {
			contact = queueItem?.domainUsers?.find((participant) => participant?.phoneNumber?.slice(-8) !== tokenParsed?.phoneNumber?.slice(-8));
		}
		// console.log("CONTACTTE", queueItem);

		if (queueItem?.domainActivity?.domain === "TASK" || queueItem?.domainActivity?.domain === "CALLBACK") {
			router.push("/task/" + queueItem?.id);
		}
		else if (contact?.organizationUser?.id && contact?.organizationUser?.status !== "SCHEDULED_FOR_DELETION") {
			router.push("/contact/" + contact?.organizationUser?.id);
		}
		else if (queueItem.type === "TASK") {
			router.push("/task/" + queueItem.id);
		}
		else {
			// console.log("handleActivityClick: ", contact?.id);
			router.push("/newcontact/s/" + contact?.id);
		}
	};

	const customer = queueItem?.domainUsers?.find((participant) => participant?.category?.substring(0, 8) === "CUSTOMER");
	const employees = queueItem?.domainUsers?.filter((participant) => participant?.category?.substring(0, 8) === "EMPLOYEE");

	const employeeFrom = queueItem?.domainUsers?.find((participant) => participant?.phoneNumber?.slice(-8) !== tokenParsed?.phoneNumber?.slice(-8));
	// eslint-disable-next-line prefer-const
	let customerFirstName = "";
	// eslint-disable-next-line prefer-const
	let customerLastName = "";
	// eslint-disable-next-line prefer-const
	let customerPhoneNumber = "";
	// eslint-disable-next-line prefer-const
	let subTitleFromLocal = false;
	// eslint-disable-next-line prefer-const
	let differingNamesStored = false;
	if (customer) {
		if (customer?.organizationUser?.status === "SCHEDULED_FOR_DELETION") {
			//Anonymiser
			customerFirstName = customer?.firstName;
			customerLastName = customer?.lastName;
		}
		else {
			customerFirstName = customer?.organizationUser?.firstName ?? customer?.firstName;
			customerLastName = customer?.organizationUser?.lastName ?? customer?.lastName;
		}

		if (domain === "EMAILING") {
			title = customerFirstName
				? customerFirstName + " " + customerLastName
				: customer?.emailAddress;
		}
		else if (domain === "TELEPHONY") {
			title =
				customerFirstName && customerFirstName.length > 0
					? customerFirstName + " " + customerLastName
					: nameSuggestion?.name;
			if (localName && title !== nameSuggestion?.name) {
				subTitle = customer?.phoneNumber;
			}
			else {
				subTitle = customer?.phoneNumber;
			}
			title = title ? truncate(title, 20) : t("Unknown number");
		}
	}
	if (!customer && employees?.length > 1) {
		customerFirstName = employeeFrom?.organizationUser?.firstName ?? employeeFrom?.firstName;
		customerLastName = employeeFrom?.organizationUser?.lastName ?? employeeFrom?.lastName;
		customerPhoneNumber = employeeFrom?.organizationUser?.phoneNumber ?? employeeFrom?.phoneNumber;
		title =
			customerFirstName || customerLastName
				? customerFirstName + " " + customerLastName
				: nameSuggestion?.name;
		subTitle = customerPhoneNumber;
	}

	if (domain === "TELEPHONY") {
		// if (!item?.domainActivity?.startedAt) {
		// 	//De som vises i rødt er ikke samtaler, bare anrop
		// 	colorText = "red";
		// }
	}
	else if (domain === "TASK") {
		if (
			queueItem?.domainActivity?.additionalData?.type === "SETTINGS_REMINDER" &&
			queueItem?.status !== "DONE"
		) {
			//doubleCheckReminderDone(queueItem?.id).then((r) => {});
		}

		const chosenUser = queueItem?.additionalData?.chosenUser;
		const regularTask = queueItem?.domainActivity?.additionalData?.type !== "CALLBACK";

		const itemTitle = queueItem?.title?.replace(/[.]+/g, "") ?? "Undefined";
		const itemSubTitle = queueItem?.subTitle?.replace(/\./g, "") ?? "Undefined";
		title = t(itemTitle);
		subTitle = t(itemSubTitle);

		if (subTitle?.length > 0) {
			subTitle = subTitle;
		}
		else if (nameSuggestion?.name) {
			subTitle = nameSuggestion?.name;
		}
		if (
			queueItem?.domainActivity?.additionalData?.type === "CALLBACK" ||
			queueItem?.domainActivity?.additionalData?.type === "REMINDER" ||
			queueItem?.domainActivity?.additionalData?.type === "CALLTO"
		) {
			const add = queueItem?.additionalData ?? queueItem?.domainActivity?.additionalData;
			const tempChosenUser = add?.chosenUser ?? chosenUser;
			const customer =
				tempChosenUser ??
				queueItem?.domainActivity?.customer ??
				add?.customer?.[0]?.domainUser ??
				add?.customer ??
				add?.userStandIn;

			const callOnlyNoCallback =
				queueItem?.domainActivity?.additionalData?.type === "CALLTO" ?? add?.noItem ?? false;
			const properCallback = add?.callId ?? false;
			const regularQuickTask = add?.type === "REMINDER" || add?.taskType === "REMINDER";
			const nameString =
				(chosenUser?.firstName
					? chosenUser?.firstName + " " + chosenUser?.lastName + ", " + chosenUser?.phoneNumber
					: nameSuggestion?.name) ??
				nameSuggestion?.name ??
				customer?.phoneNumber ??
				customer;

			const realTitle = !properCallback
				? regularQuickTask
					? t("Task") + ": " + queueItem?.title
					: t("Remember to call") /* + (chosenUser ? ': ' + chosenUser.firstName : '')*/
				: t("Remember to call back");

			title = realTitle;

			subTitle =
				t(queueItem?.subTitle?.replace(/\./g, ""));
			subSubTitle =
				(regularTask //Vanlig oppgave?
					? chosenUser || customer //Tilknyttet bruker?
						? nameString //Tilknyttet bruker?
							? nameString
							: chosenUser?.phoneNumber ?? nameSuggestion?.name
						: ""
					: properCallback //Ring tilbake?
						? chosenUser || customer //Tilknyttet bruker?
							? nameString
							: ""
						: callOnlyNoCallback //Husk å ring?
							? chosenUser || customer //Tilknyttet bruker?
								? nameString
								: ""
							: queueItem?.domainActivity?.additionalData?.receiver
								? queueItem?.domainActivity?.additionalData?.receiver
								: nameSuggestion?.name);


		}
	}

	useEffect(() => {
		if (idx !== 0 && idx % 15 === 0 && inView) {
			fetchMoreQueueItems();
		}
	}, [inView]);

	const isUnanweredPhone = () => {
		if (queueItem?.domainActivity?.domain === "TELEPHONY") {
			if (!queueItem?.domainActivity?.startedAt) { return false; }
		}
		return true;
	};
	if (!queueItem) {
		return <Typography>NO QUEUE</Typography>;
	}
	return (
		<ListItemWrapper
			ref={ref}
			disablePadding
			secondaryAction={
				<Box sx={{display: "flex", flexDirection: "column"}}>
					<ListItemMenuButton
						menuItems={listItemMenuItems}
					>
						<FontAwesomeIcon icon={faEllipsisH} size={"xs"}/>
					</ListItemMenuButton>
					<ListItemSecondaryActionTime time={queueItem?.createdAt}/>
				</Box>
			}
		>
			<ListItemButtonWrapper
				onClick={() => handleActivityClick(queueItem)}
				active={active.toString()}
				height={70}
			>
				<ListItemAvatar sx={{minWidth: 50}}>
					<Avatar sx={{bgcolor: "#3b5999", width: 34, height: 34 }}>
						<ActivityIcon item={queueItem?.domainActivity ?? queueItem?.type} type={queueItem.additionalData?.taskType}/>
					</Avatar>
				</ListItemAvatar>
				<Box sx={{maxWidth: "220px"}}>
					<ListItemText primary={title}
								  slotProps={{
									  primary: {
										  style: {
											  color: isUnanweredPhone() ? "#404040" : "#e12424",
											  fontWeight: "bold",
											  fontSize: "14px",
											  whiteSpace: "nowrap",
											  overflow: "hidden",
											  textOverflow: "ellipsis"
								  }}}}
					/>
					<ListItemText primary={subTitle}
								  slotProps={{
									  primary: {
										  style: {
											  whiteSpace: "nowrap",
											  overflow: "hidden",
											  textOverflow: "ellipsis"
										  }
									  }
								  }}
					/>
					<ListItemText primary={subSubTitle}
								 slotProps={{
									 primary: {
										 style: {
											 whiteSpace: "nowrap",
											 overflow: "hidden",
											 textOverflow: "ellipsis"
										 }
									 }
								 }}
					/>
				</Box>
				{ showStatus &&
							<ListItemText
								primary={queueItem?.status}
								slotProps={{
									primary: {
										style: {
											color: "#404040",
											fontWeight: "bold",
											fontSize: "14px"
										}
									}
								}}
								sx={{display: "flex", justifyContent: "flex-end", mr: "100px"}}
							/>
				}
			</ListItemButtonWrapper>
		</ListItemWrapper>
	);
};

export default ActivityListItem;
